import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotMovies from './components/HotMovies';
import LatestMovies from './components/LatestMovies';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotMovies />
        <LatestMovies />
      </main>
      <Footer />
    </>
  );
}